// Import modules...
import Vue from 'vue';
import { createInertiaApp } from '@inertiajs/vue2'
import PortalVue from 'portal-vue';
import VueI18n from 'vue-i18n';
import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.config.devtools = true;
function loadMessages() {
    const context = require.context("./locales", true, /[a-z0-9-_]+\.json$/i);

    const messages = context
        .keys()
        .map((key) => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
        .reduce(
            (messages, { key, locale }) => ({
                ...messages,
                [locale]: context(key),
            }),
            {}
        );

    return { context, messages };
}


Vue.mixin({ methods: { route } });
Vue.use(PortalVue);
Vue.use(VueI18n);

const { context, messages } = loadMessages();

const i18n = new VueI18n({
    locale: window.currentLocale ?? 'it',
    fallbackLocale: 'en',
    messages
})

// Vue.prototype.$axios = axios;

// const app = document.getElementById('app');
//
// new Vue({
//     i18n,
//     render: (h) =>
//         h(InertiaApp, {
//             props: {
//                 initialPage: JSON.parse(app.dataset.page),
//                 resolveComponent: (name) => require(`./Pages/${name}`).default,
//             },
//         }),
// }).$mount(app);

// createInertiaApp({
//     resolve: name => require(`./Pages/${name}`),
//     setup({ el, App, props, plugin }) {
//         Vue.use(plugin)
//
//         new Vue({
//             i18n,
//             render: h => h(App, props),
//         }).$mount(el)
//     },
// });

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        Vue.use(plugin)

        new Vue({
            i18n,
            render: h => h(App, props),
        }).$mount(el)
    },
})
